import gql from 'graphql-tag';

export const HIGHLIGHT_FRAGMENT = gql`
  fragment HighlightFragment on Highlight {
    id
    name
  }
`;
